import { useQuery } from "@apollo/client";
import { TemplateType, FilteredMattersOrderBy, Matter } from "../../../src/gql/graphql";
import { MATTER_TEMPLATE_LIST_ITEMS_QUERY } from "../../graphql/query";

export type MatterTemplateListItem = Matter;

export function useMatterTemplateQuery(
  offset: number,
  limit: number,
  templateType: TemplateType,
  orderBy: FilteredMattersOrderBy,
  search: string | null,
  orgUnitFilter?: number | null
) {
  const { loading, data, fetchMore, variables, refetch } = useQuery(
    MATTER_TEMPLATE_LIST_ITEMS_QUERY,
    {
      variables: {
        offset,
        limit,
        templateType,
        orderBy,
        search,
        orgUnitFilter: orgUnitFilter ?? null,
      },
    }
  );

  const total = data?.matterTemplates.total;

  return {
    loading,
    total,
    variables,
    matterTemplates: data?.matterTemplates.items,
    fetchMore: (offset: number) =>
      fetchMore({
        variables: {
          offset,
        },
      }),
    refetch,
  };
}
